import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

import FrontDeskApp from '@frontdesk/App';
import PortalApp from '@portal/App';
import { registerServiceWorker } from './updates';

/**
 * Two apps, one repo, one deployment.
 *
 *   /         -> front desk (offline-first PWA, the front desk PC)
 *   /portal   -> management portal (online, read-only, managers)
 *
 * They share /shared for types, date math, money and pricing logic. Splitting
 * them into two Vite builds would double the deploy surface for no gain — the
 * service worker precaches the shell either way, and the portal simply fails
 * gracefully when offline because it needs live Supabase data.
 */
registerServiceWorker();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/portal/*" element={<PortalApp />} />
        <Route path="/*" element={<FrontDeskApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
